import ChannelAdaptations from "./ChannelAdaptations";

export default ChannelAdaptations;
